/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   Detail entity constants
 */

export const START_FETCHING_ENTITY = '@@nzr/Detail/START_FETCHING_ENTITY'
export const CLEAR_ENTITY = '@@nzr/Detail/CLEAR_ENTITY'
export const DONE_FETCHING_ENTITY = '@@nzr/Detail/DONE_FETCHING_ENTITY'
export const ERROR_FETCHING_ENTITY = '@@nzr/Detail/ERROR_FETCHING_ENTITY'
export const RECEIVE_ENTITY = '@@nzr/Detail/RECEIVE_ENTITY'
export const CANCEL_FETCHING_ENTITY = '@@nzr/Detail/CANCEL_FETCHING_ENTITY'
